const DisplayTypeTab = () => {
  return <div>Display Type</div>;
};
export default DisplayTypeTab;
